import { Maybe, Retainage } from 'src/models';

export interface RetainageState extends Record<string, unknown> {
  retainage: Maybe<Retainage>;
}

export const INITIAL_RETAINAGE_STATE: RetainageState = {
  retainage: undefined,
};
